<template>
  <ValidationObserver slim v-slot="{ handleSubmit, invalid }" ref="observer">
    <form class="max-w-lg mx-auto" @submit.prevent="handleSubmit(submitAction)">
      <BaseLayoutSpaced relaxed>
        <ValidationProvider
          name="name"
          vid="name"
          rules="required|max:255"
          v-slot="{ errors, failed }"
          slim
        >
          <BaseFormGroup>
            <BaseFormLabel for="name"> Name * </BaseFormLabel>
            <BaseFormInput id="name" v-model="data.name" :disabled="submitting" :invalid="failed" />
            <BaseFormInlineMessage v-if="failed" danger>
              {{ errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </ValidationProvider>

        <ValidationProvider
          v-if="withOptional.indexOf('ownerUserId') > -1"
          key="ownerUserId"
          name="owner"
          vid="ownerUserId"
          v-slot="{ errors, failed }"
          slim
        >
          <BaseFormGroup>
            <BaseFormLabel for="ownerUserId"> Owner </BaseFormLabel>
            <div>
              <BaseFormSelect
                id="ownerUserId"
                v-model="data.ownerUserId"
                :disabled="submitting"
                :options="memberOptions"
                :invalid="failed"
              />
            </div>
            <BaseFormInlineMessage v-if="failed" danger>
              {{ errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </ValidationProvider>

        <ValidationProvider
          v-if="withOptional.indexOf('description') > -1"
          key="description"
          name="description"
          vid="description"
          rules="max:500"
          v-slot="{ errors, failed }"
          slim
        >
          <BaseFormGroup>
            <BaseFormLabel for="description"> Description </BaseFormLabel>
            <BaseFormTextarea
              id="description"
              v-model="data.description"
              :disabled="submitting"
              :invalid="failed"
            />
            <BaseFormInlineMessage v-if="failed" danger>
              {{ errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </ValidationProvider>

        <BaseFormInlineMessage v-if="message" danger>
          {{ message }}
        </BaseFormInlineMessage>

        <div>
          <BaseButton primary type="submit" :disabled="invalid || submitting">
            <span v-if="!submitting">Υποβολή</span>
            <Loader v-else small inverse />
          </BaseButton>
        </div>
      </BaseLayoutSpaced>
    </form>
  </ValidationObserver>
</template>

<script>
import { mapActions } from 'vuex';
import { HTTP_UNPROCESSABLE_ENTITY } from '@/api/http-response-codes';

export default {
  name: 'ProjectForm',

  props: {
    accountId: {
      type: String,
      required: true,
    },
    clientUuid: {
      type: String,
      required: true,
    },
    withOptional: {
      type: Array,
      default: () => [],
    },
    defaultProjectName: {
      type: String,
      default: '',
    },
  },

  data: (vm) => ({
    data: {
      name: vm.defaultProjectName,
      clientUuid: vm.clientUuid,
      description: null,
    },
    submitting: false,
    message: null,
  }),

  computed: {
    members() {
      return this.$store.getters['ui/accountMembers/membersByAccount'](this.accountId);
    },
    memberOptions() {
      return this.members.map((member) => ({
        value: member.id,
        label: member.fullName,
      }));
    },
  },

  created() {
    this.init();
  },

  methods: {
    ...mapActions('ui/accountProjects', ['storeAccountProject']),
    async init() {
      try {
        await this.$store.dispatch({
          type: 'ui/accountMembers/load',
          accountId: this.accountId,
        });
      } catch (error) {
        //
      }
    },
    async submitAction() {
      try {
        this.submitting = true;

        const payload = {
          accountId: this.accountId,
          params: this.data,
        };

        const { projectId } = await this.storeAccountProject(payload);

        this.$emit('created', projectId);
      } catch (error) {
        if (!error.response) return;

        const { status, data } = error.response;

        const { message = null } = data;

        this.message = message;

        if (status === HTTP_UNPROCESSABLE_ENTITY) this.submitting = false;
      }
    },
  },
};
</script>
